export default __webpack_public_path__ + "static/media/Group_1.d24c8ee2.png";